import { render, staticRenderFns } from "./CustomerSegment.vue?vue&type=template&id=293446ec&"
import script from "./CustomerSegment.vue?vue&type=script&lang=js&"
export * from "./CustomerSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports